var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\n      .cls-2 {\n        fill: #bfbfbf;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.000,7.949 C7.000,7.949 14.000,0.011 14.000,0.011 C14.000,0.011 0.000,0.011 0.000,0.011 C0.000,0.011 7.000,7.949 7.000,7.949 Z",
    id: "path-1",
    className: "cls-2",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.16b0d83d.svg";
export { ForwardRef as ReactComponent };